<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="layout--main"
    :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }]"
  >
    <vx-tour :steps="steps" v-if="!disableThemeTour" />
    <div v-if="!managemnetDashboard">
      <vx-sidebar
        :sidebarItems="sidebarItems"
        :logo="require('@/assets/images/logo/dark_logo.png')"
        title="آواژنــــگ"
        parent=".layout--main"
      />
    </div>
    <div
      id="content-area"
      :class="[
        contentAreaClass,
        {
          'show-overlay': bodyOverlay,
          managemnetDashboard: managemnetDashboard
        }
      ]"
    >
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          v-if="!managemnetDashboard"
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
            { managemnetDashboardnav: managemnetDashboard }
          ]"
        />

        <div class="router-view">
          <div
            class="router-content"
            :class="{ 'mt-0': navbarType == 'hidden' }"
          >
            <div v-if="managemnetDashboard" class="logo">
              <router-link
                :to="{ path: '/dashboard/analytics' }"
                target="_blank"
              >
                <img src="../../assets/images/logo/avajanglogo.jpg" />
              </router-link>
            </div>
            <transition :name="routerTransition" v-if="!managemnetDashboard">
              <div
                class="router-header flex flex-wrap items-center mb-6"
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
              >
                <div
                  class="content-area__heading"
                  :class="{
                    'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light':
                      $route.meta.breadcrumb
                  }"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                />
              </div>
            </transition>
            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg"
                />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue";
import TheCustomizer from "../components/customizer/TheCustomizer.vue";
import TheNavbar from "../components/TheNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";
import BackToTop from "vue-backtotop";
const VxTour = () => import("@/components/VxTour.vue");

export default {
  data() {
    return {
      titleMassege:
        "هرگونه انتقاد ، نظر و پیشنهادات خود را از طریق نظرسنجی در بالای صفحه اعلام کنید.",
      textUpdateList: [
        "امکان افزودن اعضاء برای نماینده",
        "بهبود تم دارک",
        "اصلاح درخواستی در چاپ کارت گارانتی",
        "رفع مشکلات جزیی در ثبت مجوز خروج با بارکدخوان",
        "امکان ثبت کمیسیون برای سفارشات وبسایت",
        "امکان بازگشت به صفحه مبدا در سفارشات وبسایت(دکمه بازگشت)"
      ],
      textUpdateList_1_6_2: [
        {
          name: "امکان انتخاب ادرس در هنگام ثبت سفارش",
          subName: []
        }
      ],
      textUpdateList_1_6: [
        {
          name: "امکان فیلتر در سفارشات نمایندگان",
          subName: []
        },
        {
          name: "امکان فیلتر در سفارشات وبسایت",
          subName: []
        },
        {
          name: "نمایش مجموع تعداد آیتم‌ها در جزییات سفارشات نماینده",
          subName: []
        },

        {
          name: "امکان تعریف صفت برای کالا در هنگام تعریف مشخصات کالا",
          subName: [
            "این مورد در دسته-مدیریت محصولات بود و اکنون به سایدبار منتقل شده"
          ]
        },
        {
          name: "رفع مشکل در ویرایش عکس رسید در مرسولات",
          subName: []
        },
        {
          name: "رفع برخی مشکلات جزیی",
          subName: []
        }
      ],
      textUpdateList_1_5_2: [
        {
          name:
            "امکان بازگشت به صفحه مبدا و حفظ تغییرات اعمال شده با استفاده از دکمه بازگشت در",
          subName: [
            "سیستم حمل و نقل ، مرسولات ، جزییات",
            "سیستم انبار ، مجوز خروج ، جزییات",
            "سیستم انبار ، حواله خروج ، جزییات",
            "سیستم فروش ، سهمیه بندی ، جزییات",
            "سیستم سفارشات ، سفارش وبسایت ، جزییات",
            "سیستم سفارشات ، سفارش نمایندگان ، جزییات"
          ]
        },
        {
          name:
            "نمایش کد نماینده در سیستم فروش ، سهمیه بندی ، گزارش سهمیه ، جزییات",
          subName: []
        },
        {
          name:
            "امکان دریافت گزارش سامانه جامع مالیاتی در مدیریت فروش ، فاکتورها",
          subName: []
        },
        {
          name:
            "امکان مشاهده متصدیان فروش هر نماینده در مدیریت طرفهای تجاری ، نمایندگان",
          subName: []
        },
        {
          name:
            "امکان ثبت اطلاعات مالیاتی برای نمایندگان در مدیریت طرفهای تجاری ، نمایندگان",
          subName: []
        },
        {
          name: "افزودن رنگ درخواستی در مدیریت محصولات ، محصولات ، جزییات",
          subName: []
        },
        {
          name: "رفع برخی ایرادات جزیی",
          subName: []
        }
      ],
      textUpdateList_1_3_2: ["امکان حذف اعضاء برای نماینده", "بهبود تم دارک"],
      navbarType: themeConfig.navbarType || "floating",
      navbarColor: themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      onShowUpdateChanges1_6_2: "",
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour,
      steps: [
        {
          target: "#btnSidebarToggler",
          content: "Toggle Collapse Sidebar."
        },
        {
          target: ".vx-navbar__starred-pages",
          content:
            "Create your own bookmarks. You can also re-arrange them using drag & drop."
        },
        {
          target: ".i18n-locale",
          content: "You can change language from here."
        },
        {
          target: ".navbar-fuzzy-search",
          content: "Try fuzzy search to visit pages in flash."
        },
        {
          target: ".customizer-btn",
          content: "Customize template based your preference",
          params: {
            placement: "left"
          }
        },
        {
          target: ".vs-button.buy-now",
          content: "Buy this awesomeness at affordable price!",
          params: {
            placement: "top"
          }
        }
      ],
      managemnetDashboard: false
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      if (this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    }
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor("#fff");
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      this.disableThemeTour = true;
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    }
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    TheCustomizer,
    BackToTop,
    VxTour
  },
  created() {
    if (this.$route.path === "/ManagementDashboard") {
      this.managemnetDashboard = true;
    }
    this.setSidebarWidth();
    if (this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("+fff");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
    this.titleMassege =
      "</br></p style='font-size: 14px;'>**" + this.titleMassege + "</p>";
    this.onShowUpdateChanges1_6_2 = localStorage.getItem(
      "ShowUpdateChanges1_6_2"
    );
    if (this.onShowUpdateChanges1_6_2 != "shown1_6_2") {
      var TextUpdate = "";
      for (let index = 0; index < this.textUpdateList_1_6_2.length; index++) {
        TextUpdate +=
          "<p style='font-size: 14px;text-align: start;'>--  " +
          this.textUpdateList_1_6_2[index].name;

        if (this.textUpdateList_1_6_2[index].subName.length) {
          TextUpdate += " :";
        }
        TextUpdate += "</p></br>";
        for (
          let subIndex = 0;
          subIndex < this.textUpdateList_1_6_2[index].subName.length;
          subIndex++
        ) {
          TextUpdate +=
            "<p style='text-align: start;font-size: 12px;'>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp- " +
            this.textUpdateList_1_6_2[index].subName[subIndex];
          TextUpdate += "</p></br>";
        }
      }
      this.$swal({
        position: "bottom-start'",
        html: TextUpdate + this.titleMassege,
        style: "text-align:left",
        title: "لیست به‌روز‌رسانی نسخه 1.6.2"
      });

      // localStorage.setItem("ShowUpdateChanges", "shown");
      localStorage.setItem("ShowUpdateChanges1_6_2", "shown1_6_2");
    }
  }
};
</script>
<style scoped lang="css">
.swal2-content {
  text-align: start;
  line-height: 15px;
}
.swal2-content h6{
  line-height: 25px;
}
.swal2-popup{
  width: 42em;
}
</style>
